import type { MultiselectCustomerPartialEntity } from '../../../components/global/ConfigurationMultiselect/configurationMultiselectTypes';

export const customerIDThenTitleSorter = (
  left: MultiselectCustomerPartialEntity,
  right: MultiselectCustomerPartialEntity,
): number => {
  const result = left.customerId.localeCompare(right.customerId);
  if (result !== 0) {
    return result;
  } else {
    return left.title.localeCompare(right.title);
  }
};
